import React from "react";
import {
  Pane,
  Dialog,
  Badge,
  Text,
  Strong,
  Button,
  Heading,
  PhoneIcon,
} from "evergreen-ui";
import { withRouter } from "react-router-dom";

import { getFormattedTime, getCurrency, checkIntOrFloat } from "../util";

const BulkBookingDetailsDialog = (props) => {
  const {
    isShown,
    showDialog,
    bookingDetails,
    showConfirmationDialog,
    cancelBooking,

    showBookingTransactionsDialog,

    printStatement,

    daysData,
  } = props;

  let {
    sport,
    bookingId,
    bookingType,
    courts,

    startDate,
    endDate,
    dateBooked,
    startTime,
    endTime,
    customerDetails,
    grossAmount,
    discount,
    paymentMode,
    advance,
    days,
    slotCount,
    cancelled,
    isPlayoBooking,

    patternBookingId,
  } = bookingDetails;

  const currency = getCurrency();

  return (
    <Dialog
      isShown={isShown}
      title={"Booking Details"}
      onCloseComplete={() => showDialog(false)}
      hasFooter={false}
    >
      <Pane
        display={"flex"}
        justifyContent={"flex-end"}
        borderBottom={"default"}
        marginBottom={10}
      >
        <Button
          appearance={"minimal"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          iconBefore={"changes"}
          marginRight={10}
          padding={0}
          onClick={() => showBookingTransactionsDialog(true, patternBookingId)}
        >
          Transactions
        </Button>
        <Button
          appearance={"minimal"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          iconBefore={"document-open"}
          marginLeft={10}
          padding={0}
          onClick={() => printStatement(patternBookingId, true)}
        >
          Statement
        </Button>
      </Pane>

      <Pane
        display={"flex"}
        flexDirection={"column"}
        borderBottom={"default"}
        marginBottom={10}
      >
        <Pane
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          // justifyContent={isPlayoBooking ? "space-between" : "flex-start"}
          marginBottom={10}
          width={"full"}
        >
          <Badge
            color={"#3366FF"}
            display={"flex"}
            flexDirection="row"
            alignItems={"center"}
            height={"20px"}
            maxWidth={"max-content"}
            isSolid
          >
            <Strong color={"white"} alignItems={"center"} size={300}>
              {sport}
            </Strong>
          </Badge>
          {isPlayoBooking ? (
            <Pane
              display={"flex"}
              marginTop={"10px"}
              alignItems="center"
              flexDirection="row"
            >
              {/* <img
                height={"20px"}
                alt='playo-logo'
                width={"20px"}
                src='https://playo-website.gumlet.io/playo-website-v2/logos-icons/Playo+Logo+-+Ball+Boxed.svg'
              /> */}
              <Badge
                background={"#00B562"}
                display="flex"
                alignItems={"center"}
                flexDirection="row"
                isSolid
                height={"20px"}
              >
                Playo Booking
              </Badge>
            </Pane>
          ) : null}
        </Pane>
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={"column"}
          marginBottom={10}
        >
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Heading size={100}>Pattern Booking ID</Heading>
            {<Heading size={100}>Type</Heading>}
          </Pane>
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Strong>{patternBookingId}</Strong>

            {<Text>{"Bulk"}</Text>}
          </Pane>
        </Pane>
        <Pane
          display={"flex"}
          width={"100%"}
          marginY={5}
          justifyContent={"space-between"}
          flexDirection={"row"}
        >
          <Pane
            display={"flex"}
            width={"100%"}
            marginY={10}
            justifyContent={"space-between"}
            flexDirection={"column"}
          >
            <Text>Court</Text>
            <Pane flexDirection={"row"} gap={2} display="flex">
              {courts?.map((court, index) => (
                <React.Fragment key={index}>
                  <Strong>{court}</Strong>
                  {index !== courts.length - 1 && ", "}
                </React.Fragment>
              ))}
            </Pane>
          </Pane>
          <Pane
            display={"flex"}
            width={"100%"}
            marginY={10}
            alignItems={"end"}
            justifyContent={"end"}
            flexDirection={"column"}
          >
            <Text>Slot</Text>
            <Pane flexDirection={"row"} gap={2} display="flex">
              <Strong>{slotCount}</Strong>
            </Pane>
          </Pane>
        </Pane>
        <Pane
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={"100%"}
        >
          <Pane
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            width={"100%"}
            alignItems={"center"}
          >
            <Pane
              width={"100%"}
              display={"flex"}
              flexDirection="column"
              alignItems={"start"}
              marginBottom={10}
            >
              <Text>Days</Text>
              <Strong marginTop={8}>
                {days?.length === 7
                  ? "All"
                  : days?.map((day, index) => {
                      if (index === days?.length - 1) {
                        return (
                          daysData[day] ||
                          day[0].toUpperCase() + day.substring(1, 3)
                        );
                      } else {
                        return (
                          (daysData[day] ||
                            day[0].toUpperCase() + day.substring(1, 3)) + ", "
                        );
                      }
                    })}
              </Strong>
            </Pane>
            <Button
              width={"100%"}
              display={"flex"}
              flexDirection="column"
              background="tint2"
              color="black"
              alignItems={"center"}
              onClick={() =>
                (window.location.href = `search?bookingId=${patternBookingId}&bookingClick=false`)
              }
            >
              See All Bookings
            </Button>
          </Pane>
          <Pane
            display={"flex"}
            width={"100%"}
            marginY={8}
            justifyContent={"space-between"}
            flexDirection={"row"}
          >
            <Text>From Date</Text>
            <Text>To Date</Text>
          </Pane>
          <Pane
            display={"flex"}
            width={"100%"}
            justifyContent={"space-between"}
            flexDirection={"row"}
            marginBottom={10}
          >
            <Strong>{startDate}</Strong>
            <Strong>{endDate}</Strong>
          </Pane>
        </Pane>
      </Pane>
      <Pane
        display={"flex"}
        flexDirection={"column"}
        borderBottom={"default"}
        marginBottom={10}
      >
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={"column"}
          marginBottom={10}
        >
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Heading size={100}>Name</Heading>
            <Heading size={100}>Phone Number</Heading>
          </Pane>
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Text>{customerDetails && customerDetails["name"]}</Text>
            <Pane
              display={"flex"}
              flexDirection="row"
              justifyContent={"flex-end"}
            >
              <div className={"solid-icon-container"}>
                <PhoneIcon size={8} color="white" />
              </div>
              {customerDetails && (
                <Strong
                  is="a"
                  href={`tel:${customerDetails.customerMobile}`}
                  className={"no-underline"}
                >
                  {customerDetails["mobile"]}
                </Strong>
              )}
            </Pane>
          </Pane>
        </Pane>
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          flexDirection={"column"}
          marginBottom={10}
        >
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Heading size={100}>Email</Heading>
          </Pane>
          <Pane display={"flex"} justifyContent={"space-between"}>
            <Text>{customerDetails && customerDetails["email"]}</Text>
          </Pane>
        </Pane>
      </Pane>

      <Pane
        display={"flex"}
        justifyContent={"space-between"}
        flexDirection={"column"}
        borderBottom={"default"}
        marginBottom={10}
      >
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={8}
        >
          <Heading size={100}>
            <b>Gross</b>
          </Heading>
          <Text>{`${currency} ${checkIntOrFloat(grossAmount)}`}</Text>
        </Pane>
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={8}
        >
          <Heading size={100}>
            <b>Discount</b>
          </Heading>
          <Text>{`${currency} ${checkIntOrFloat(discount)}`}</Text>
        </Pane>
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={8}
        >
          <Heading size={100}>
            <b>Advance</b>
          </Heading>
          <Text>{`${currency} ${checkIntOrFloat(advance)}`}</Text>
        </Pane>
        <Pane
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={10}
        >
          <Heading size={100}>
            <b>Payment Mode</b>
          </Heading>
          <Text>{paymentMode}</Text>
        </Pane>
      </Pane>

      {/* {type === 1 && (
        <Pane
          display={"flex"}
          flexDirection={"column"}
          borderBottom={"default"}
          marginBottom={10}
        >
          <Pane
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            marginBottom={10}
          >
            <Strong>Balance</Strong>
            <Pane display={"flex"} alignItems={"center"}>
              <Strong>{`${currency} ${balance}`}</Strong>
              {balance && !bookingCancelled ? (
                <Button
                  marginLeft={10}
                  appearance={"primary"}
                  onClick={() => showPayNowDialog(true)}
                >
                  Pay Now
                </Button>
              ) : (
                <React.Fragment />
              )}
            </Pane>
          </Pane>
        </Pane>
      )} */}

      {isPlayoBooking ? (
        <Pane display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <Text size={100} color={"muted"}>
            <em>Contact Playo to modify Playo bookings</em>
          </Text>
        </Pane>
      ) : (
        <React.Fragment>
          {cancelled === 1 ? (
            <Pane
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Text size={100} color={"muted"}>
                <em>Booking is Cancelled</em>
              </Text>
            </Pane>
          ) : (
            <Pane
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={10}
            >
              <Button
                className={"cancel-button"}
                intent={"danger"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                width={"100%"}
                marginLeft={5}
                onClick={() => {
                  showDialog(false);
                  showConfirmationDialog({
                    status: true,
                    header: "Booking Cancellation",
                    confirmLabel: "Yes",
                    cancelLabel: "No",
                    intent: "danger",
                    information: (
                      <Pane display={"flex"} flexDirection={"column"}>
                        <Pane
                          display={"flex"}
                          flexDirection={"row"}
                          flexBasis={"100%"}
                          justifyContent={"space-between"}
                          marginBottom={10}
                        >
                          <Strong textDecoration={"underline"}>
                            {patternBookingId}
                          </Strong>
                          {/* <Text>{courts}</Text> */}
                        </Pane>
                        <Pane
                          marginY={10}
                          display={"flex"}
                          flexDirection={"column"}
                          justifyContent={"space-between"}
                        >
                          <Pane
                            display={"flex"}
                            width={"100%"}
                            marginBottom={5}
                            justifyContent={"space-between"}
                            flexDirection={"row"}
                          >
                            <Strong>From Date</Strong>
                            <Strong>To Date</Strong>
                          </Pane>
                          <Pane
                            display={"flex"}
                            width={"100%"}
                            justifyContent={"space-between"}
                            flexDirection={"row"}
                            marginBottom={5}
                          >
                            <Text>{startDate}</Text>
                            <Text>{endDate}</Text>
                          </Pane>
                        </Pane>
                        <Pane
                          display={"flex"}
                          flexDirection={"row"}
                          flexBasis={"100%"}
                          justifyContent={"space-between"}
                          marginBottom={10}
                        >
                          {/* <Strong>
                            {" "}
                            {getFormattedDate(
                              timestamp,
                              "YYYY-MM-DD HH:mm:ss",
                              "ddd, Do MMM"
                            )}
                          </Strong> */}
                          <Strong>
                            {`${getFormattedTime(
                              startTime
                            )} - ${getFormattedTime(endTime)}`}
                          </Strong>
                        </Pane>

                        <Pane
                          display={"flex"}
                          flexDirection={"row"}
                          flexBasis={"100%"}
                          justifyContent={"space-between"}
                        >
                          <Text>
                            {customerDetails && customerDetails["name"]}
                          </Text>
                          <Text>
                            {customerDetails && customerDetails["mobile"]}
                          </Text>
                        </Pane>
                        <Pane
                          width={"100%"}
                          marginTop={"20px"}
                          borderRadius={"5px"}
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          background={isPlayoBooking ? "#CCFFE7" : "#FFDAD4"}
                          height={"20px"}
                        >
                          <Pane
                            size="400"
                            color={isPlayoBooking ? "#00331B" : "#410001"}
                          >
                            {isPlayoBooking ? "Playo Booking" : "Club Booking"}
                          </Pane>
                        </Pane>
                      </Pane>
                    ),
                    action: () => cancelBooking(patternBookingId),
                  });
                }}
              >
                Cancel Booking
              </Button>
              {cancelled === 2 && <em>Booking is Partially cancelled</em>}
            </Pane>
          )}
        </React.Fragment>
      )}
    </Dialog>
  );
};

export default withRouter(BulkBookingDetailsDialog);
